import type { VoidFunctionComponent } from 'react';
import { useGetCurrentPlan } from '../../../../hooks/subscriptions/useGetCurrentPlan';
import Loader from '../../../generic/Loader';
import Flex from '../../../generic/Flex';
import PlanDetails from './PlanDetails';
import PlanInfo from './PlanInfo';
import { usePlansContext } from '../plans/PlansContext';

const CurrentPlan: VoidFunctionComponent = () => {
  const {
    data,
    isLoading: isLoadingCurrentPlan,
  } = useGetCurrentPlan();

  const { freePrice, isLoading: isLoadingPlans } = usePlansContext();

  if (isLoadingCurrentPlan || isLoadingPlans) {
    return (<Loader />);
  }

  if (!data || !freePrice?.product) {
    return null;
  }

  return (
    <Flex direction="column" gap={32} align="unset">
      <PlanInfo data={data} freePrice={freePrice} />
      <PlanDetails data={data} freePrice={freePrice} />
    </Flex>
  );
};

export default CurrentPlan;
